import React from "react";
import { useCalendar } from "../../pages/Calendar/state/CalendarContext";

export default function CalendarFilters() {
    const { state, dispatch } = useCalendar();

    const filters = state.settings?.calendarFilters || {};
    const colors = state.settings?.itemTypeColors || {};

    const toggleFilter = (key) => {
        dispatch({
            type: "UPDATE_CALENDAR_SETTINGS",
            payload: {
                calendarFilters: {
                    ...filters,
                    [key]: !filters[key],
                },
            },
        });
    };

    const formatLabel = (key) =>
        key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (s) => s.toUpperCase());

    return (
        <div style={{ padding: "1rem", minWidth: 0 }}>
            <h4 style={{ marginBottom: "1rem" }}>Calendar Filters</h4>

            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                {Object.keys(filters).map((key) => (
                    <label
                        key={key}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "0.95rem",
                            userSelect: "none",
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={!!filters[key]}
                            onChange={() => toggleFilter(key)}
                            style={{ marginRight: "0.5rem" }}
                        />

                        <span
                            style={{
                                width: "14px",
                                height: "14px",
                                borderRadius: "50%",
                                backgroundColor: colors[key] || "#ccc",
                                border: "1px solid #999",
                                marginRight: "0.5rem",
                                flexShrink: 0,
                            }}
                        />

                        {formatLabel(key)}
                    </label>
                ))}
            </div>
        </div>
    );
}
